import { useState, useEffect } from 'react';
import SearchStore from '../../../stores/SearchStore';
import ResultsStore from '../../../stores/ResultsStore';
import ProfileStore from '../../../stores/ProfileStore';
import SortConstants from '../../../constants/SortConstants';
import SortActions from '../../../actions/SortActions';

import Analytics from 'arbitrip-common/client/analytics';

import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import Config from 'arbitrip-common/client/utils/Config';
import { useTranslation } from 'react-i18next';

const StyledMenuItem = (props) => {
	return (
		<MenuItem
			{...props}
			sx={{
				height: '46px',
			}}
		/>
	);
};

const SortDropdownComponent = () => {
	const { t } = useTranslation();
	const [method, setMethod] = useState(ResultsStore.getSortMethod());
	const [profile, setProfile] = useState(ProfileStore.getProfile());

	useEffect(() => {
		const handleChange = () => {
			setMethod(ResultsStore.getSortMethod());
			setProfile(ProfileStore.getProfile());
		};

		ResultsStore.addChangeListener(handleChange);
		return () => ResultsStore.removeChangeListener(handleChange);
	}, []);

	const handleSortChange = (event) => {
		const value = event.target.value;

		const actionMapper = {
			[SortConstants.SORT_METHOD.RECOMMENDED]: SortActions.sortByRecommended,
			[SortConstants.SORT_METHOD.PRICE]: SortActions.sortByPrice,
			[SortConstants.SORT_METHOD.PRICE_HIGH_TO_LOW]: SortActions.sortByPriceHighToLow,
			[SortConstants.SORT_METHOD.DISTANCE]: SortActions.sortByDistance,
			[SortConstants.SORT_METHOD.REVIEWS]: SortActions.sortByReviews,
			[SortConstants.SORT_METHOD.SCORES]: SortActions.sortByScores,
			[SortConstants.SORT_METHOD.MARGIN_PERCENTAGE]: SortActions.sortByMarginPercentage,
			[SortConstants.SORT_METHOD.ABSOLUTE_MARGIN]: SortActions.sortByAbsoluteMargin,
		};

		actionMapper[value]?.();

		Analytics.actions.interactions.sortedResults(profile, value);
	};

	const labelPrefix = t('SortBy.Label');
	const distanceLabel = SearchStore.isSpecificSearch() ? t('Distance') : t('DistanceFromCenter');

	const menuItemsData = [
		{ value: SortConstants.SORT_METHOD.RECOMMENDED, label: t('SortBy.Recommended') },
		{ value: SortConstants.SORT_METHOD.PRICE, label: t('SortBy.PriceLowToHigh') },
		{ value: SortConstants.SORT_METHOD.PRICE_HIGH_TO_LOW, label: t('SortBy.PriceHighToLow') },
		{
			value: SortConstants.SORT_METHOD.DISTANCE,
			label: distanceLabel,
		},
		{ value: SortConstants.SORT_METHOD.REVIEWS, label: t('ReviewScore') },
		...(Config.research_mode
			? [
					{ value: SortConstants.SORT_METHOD.SCORES, label: t('Server') + '(*)' },
					{ value: SortConstants.SORT_METHOD.MARGIN_PERCENTAGE, label: t('MarginPercentage') },
					{ value: SortConstants.SORT_METHOD.ABSOLUTE_MARGIN, label: t('AbsoluteMargin') },
				]
			: []),
	];

	const getSelectedLabel = (value) => {
		const selectedItem = menuItemsData.find((item) => item.value === value);
		return selectedItem ? `${labelPrefix} ${selectedItem.label}` : '';
	};

	return (
		<FormControl>
			<Select
				value={method}
				onChange={handleSortChange}
				renderValue={(selected) => getSelectedLabel(selected)}
				MenuProps={{
					PaperProps: {
						style: {
							borderRadius: '8px',
						},
					},
				}}
				inputProps={{ 'data-testid': 'sort-dropdown' }}
				data-testid="sort-dropdown-wrap"
			>
				{menuItemsData.map((item) => (
					<StyledMenuItem key={item.value} value={item.value} data-testid={`sort-option-${item.value}`}>
						{item.label}
					</StyledMenuItem>
				))}
			</Select>
		</FormControl>
	);
};

export default SortDropdownComponent;
